import { TMedia } from './TMedia'
import { TMediaFile } from './TMediaFile'

export const isMediaFile = (media: TMedia): media is TMediaFile => {
  const mediaFile = media as TMediaFile

  return !!(mediaFile.attributes.ext && mediaFile.attributes.hash)
}
